import React from 'react';
import { useTranslation } from 'react-i18next';
import './Benefits.css';

const Benefits = () => {
  const { t } = useTranslation();

  const benefits = [
    {
      icon: '✓',
      title: t('benefit1Title'),
      description: t('benefit1Description'),
    },
    {
      icon: '🕐',
      title: t('benefit2Title'),
      description: t('benefit2Description'),
    },
    {
      icon: '🎯',
      title: t('benefit3Title'),
      description: t('benefit3Description'),
    },
    {
      icon: '🚀',
      title: t('benefit4Title'),
      description: t('benefit4Description'),
    },
  ];

  return (
    <section id="benefits" className="benefits" aria-label="Benefits section">
      <div className="container">
        <h2 className="section-title">{t('clientBenefits')}</h2>
        <p className="section-subtitle">{t('clientBenefitsDescription')}</p>
        <div className="benefits-content">
          <div className="benefits-grid">
            {benefits.map((benefit, index) => (
              <article key={index} className="benefit-card">
                <div className="benefit-icon" aria-hidden="true" role="img" aria-label={`${benefit.title} icon`}>{benefit.icon}</div>
                <h3 className="benefit-title">{benefit.title}</h3>
                <p className="benefit-description">{benefit.description}</p>
              </article>
            ))}
          </div>
          <div className="benefits-visual">
            <div className="benefits-image-placeholder">
              <span className="placeholder-icon" style={{ filter: 'hue-rotate(120deg) saturate(1.3) brightness(1.1)' }}>📈</span>
              <p>{t('benefitsVisual')}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Benefits;
